export default __webpack_public_path__ + "static/media/boy.ece87467.png";